import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { ROOT_MODAL_DRAWER_PROP } from 'components/Drawers/standardDrawerContract';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { preloadModalComponent } from 'components/RootModal/modalRegistry';

import type { TransactionEditDialogProps } from './types';

export const DIALOG_TYPE = 'TRANSACTION_DETAILS_DIALOG';

export const preloadTxnDetailsDialog = (): Promise<unknown> | null => preloadModalComponent(DIALOG_TYPE);

export const showTxnDetailsDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({
    txn,
    wrapperId,
    txnActionCallback,
    defaultAccountId,
    rootModalDrawer: rootModalDrawerProp,
    [ROOT_MODAL_DRAWER_PROP]: rootModalDrawer,
    ...otherProps
  }: TransactionEditDialogProps) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: `TRANSACTION_DETAILS_${txn?.id || '0'}`,
      props: ImmutableMap({
        txn,
        wrapperId,
        txnActionCallback,
        defaultAccountId,
        [ROOT_MODAL_DRAWER_PROP]: rootModalDrawer ?? rootModalDrawerProp ?? { width: 'Large', showScrim: true },
        ...otherProps,
      }),
    }),
);
